import { CxEvent } from '@spartacus/core';

export class FbqGgSearchPageEvent extends CxEvent {
  event?: string;
}
